module.exports = __webpack_public_path__ + "img/bg.0ccf9e11.png";